import { Accordion } from "react-bootstrap"
import { AiOutlineEdit } from "react-icons/ai"
import "./Selection.css"
import { useState } from "react"
import UpdateUserModal from "../Modals/UpdateUserModal"

export default function CustomerAccordion({
    eventKey,
    id,
    customer,
    refreshCallback,
    children,
}) {
    const [showEditModal, setShowEditModal] = useState(false)

    return (
        <>
        <Accordion.Item
            eventKey={eventKey}
            className="custom-accordion-item"
            id={id}
            key={id+customer}
        >
            <Accordion.Header className="custom-accordion-header">
                {customer.lastName}, {customer.firstName}
            </Accordion.Header>
            <Accordion.Body className="relative">
                {children}
                <span className="medium-font edit-user-icon" onClick={() => setShowEditModal(true)}>
                    <AiOutlineEdit />
                </span>
            </Accordion.Body>
        </Accordion.Item>
        <UpdateUserModal show={showEditModal} onClose={() => setShowEditModal(false)} user={customer} onUpdated={refreshCallback} />
        </>
    );
}
